import { render, staticRenderFns } from "./ServiceRegisterView.vue?vue&type=template&id=1dd9fbe4&"
import script from "./ServiceRegisterView.vue?vue&type=script&lang=ts&"
export * from "./ServiceRegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports